import jHome from "@/views/jp/jHome";
import jRadio from "@/views/jp/jRadio";
import videos from "@/views/jp/videos/videos";
import bibleStudy from "@/views/jp/bibleStudy";
import aboutUs from "@/views/jp/aboutUs";
import ContactInfo from "@/views/jp/ContactInfo";
import book from "@/views/jp/book";

export default [
   {
      path: '/jp',
      name: 'home',
      component: jHome
   },

   {
      path: '/jp/home',
      name: 'home',
      component: jHome
   },

   {
      path: '/jp/radio',
      name: 'home',
      component: jRadio
   },


   {
      path: '/jp/book',
      name: 'book',
      component: book
   },


   // {
   //    path: '/jp/video/namihira-story',
   //    name: 'nami_story',
   //    component: namihiraStory
   // },

   {
      path: '/jp/video/:path',
      name: 'cosmicConflict',
      component: videos
   },

   {
      path: '/jp/bible-study',
      name: 'bibleStudy',
      component: bibleStudy
   },

   {
      path: '/jp/about-us',
      name: 'aboutUs',
      component: aboutUs
   },


   {
      path: '/jp/contact-us',
      name: 'ContactInfo',
      component: ContactInfo
   },


];



